import { Typography, Form, Input, InputNumber, DatePicker, Row, Col, Button, Space } from 'antd';

import { useAuth } from '../../hooks/useAuth';
import React, { useState } from 'react';
import './CashIn.css';
import CashInService from '../../services/CashInService';
import traderService from '../../services/TraderService';

const { Title, Text } = Typography;

const CashIn = () => {
  const [tradingAccountNo, setTradingAccountNo] = useState('');
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [loading, setLoading] = useState(false);
  const onRequiredTypeChange = ({ requiredMarkValue, tradingAccountNo }) => {
    setRequiredMarkType(requiredMarkValue);
    if (tradingAccountNo) setTradingAccountNo(tradingAccountNo);
  };

  const onFinish = async formValues => {
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
      bankBalance: formValues.bankBalance,
    };

    console.log(payload);
    setLoading(true);
    const result = await CashInService.performCashIn(payload);
    setLoading(false);
    console.log(result);

    if (result.success) {
      showNotification('success', 'Added');
    } else {
      showNotification('error', result.message);
    }
  };

  const findTrader = async () => {
    console.log(tradingAccountNo);
    let response = await traderService.findTrader({
      tradingAccountNo: tradingAccountNo,
    });

    if (response.success)
      form.setFieldsValue({
        traderName: response.name,
        traderNrc: response.nrcNo,
      });
    else showNotification('error', response.message);
  };

  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Cash In
      </Title>
      <Form
        className="cashin-form"
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 8,
        }}
        onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        <Form.Item
          label="Trading Account No"
          name={'tradingAccountNo'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          {/* <Input/> */}
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input size="middle" />
            <Button type="primary" onClick={findTrader}>
              Check
            </Button>
          </Space.Compact>
        </Form.Item>
        <Form.Item label="Trader Name" name={'traderName'}>
          <Input disabled />
        </Form.Item>
        <Form.Item label="NRC / Passport" name={'traderNrc'}>
          <Input disabled />
        </Form.Item>
        <Form.Item
          label={'Bank Balance'}
          name={'bankBalance'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <InputNumber
            className="number-input"
            min={1}
            formatter={value => Number(value).toLocaleString('en-US')}
            parser={value => Number(value.toString().split(',').join(''))}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Add
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default CashIn;
